import Vue from 'vue'
import Router from 'vue-router'


Vue.use(Router);

const index = r => require.ensure([], () => r(require('@/page/website/index')), 'index');
const home = r => require.ensure([], () => r(require('@/page/website/home')), 'home');
const login = r => require.ensure([], () => r(require('@/page/login/login')), 'login');
const register = r => require.ensure([], () => r(require('@/page/login/register')), 'register');

const bs_index = r => require.ensure([], () => r(require('@/page/backstage/index')), 'bsindex');
const bsUserList = r => require.ensure([], () => r(require('@/page/backstage/bsUserList')), 'bsUserList');
const bsActivityList = r => require.ensure([], () => r(require('@/page/backstage/bsActivityList')), 'bsActivityList');
const bsRegistration = r => require.ensure([], () => r(require('@/page/backstage/bsRegistration')), 'bsRegistration');
const bsAchievementList = r => require.ensure([], () => r(require('@/page/backstage/bsAchievementList')), 'bsAchievementList');
const bsCourseList = r => require.ensure([], () => r(require('@/page/backstage/bsCourseList')), 'bsCourseList');


const categoryList = r =>require.ensure([], () => r(require('@/page/website/category/categoryList')),'categoryList');
const categoryDetails = r =>require.ensure([], () => r(require('@/page/website/category/categoryDetails')),'categoryDetails');

const activityList = r =>require.ensure([], () => r(require('@/page/website/activity/activityList')),'activityList');
const activityDetails = r =>require.ensure([], () => r(require('@/page/website/activity/activityDetails')),'activityDetails');
const activityRegistration = r => require.ensure([], () => r(require('@/page/website/activity/activityRegistration')),'activityRegistration');

const course = r =>require.ensure([], () => r(require('@/page/website/course/course')),'course');
const courseDetails = r =>require.ensure([], () => r(require('@/page/website/course/courseDetails')),'courseDetails');

const achievements = r =>require.ensure([], () => r(require('@/page/website/achievements/achievements')),'achievements');
const achievementsDetails = r =>require.ensure([], () => r(require('@/page/website/achievements/achievementsDetails')),'achievementsDetails');

const userInfo = r =>require.ensure([], () => r(require('@/page/website/user_center/user_info/user_info')),'user_info');

const finishUserInfo = r =>require.ensure([], () => r(require('@/page/website/user_center/user_info/finishUserInfo')),'finishUserInfo');
const record = r =>require.ensure([], () => r(require('@/page/website/user_center/user_info/record')),'record');
const pro = r =>require.ensure([], () => r(require('@/page/website/user_center/user_info/pro')),'pro');

const page2020d = r =>require.ensure([], () => r(require('@/page/activepage/2020dong')),'2020d');
const page2020gsj = r =>require.ensure([], () => r(require('@/page/activepage/2020gsj')),'2020gsj');
const page2021 = r =>require.ensure([], () => r(require('@/page/activepage/2021page')),'2021page');
const page2022 = r =>require.ensure([], () => r(require('@/page/activepage/2022page')),'2022page')
const page2023 = r =>require.ensure([], () => r(require('@/page/activepage/2023page')),'2023page')
const csdn2023 = r =>require.ensure([], () => r(require('@/page/activepage/2023csdn')),'2023page')
export default new Router({
  routes: [
    {
      path: '/login',
      component: login,
    },
    {
      path: '/register',
      component: register,
    },
    {
      path: '/home',
      component: home,
      meta: [],
    },
    {
      path: '/',
      component: index,
      children: [
        {
            path: '',
            redirect:'/home',
            meta: [],
        },
        {
          path:'/recruit',
          redirect:'/home'
        },
        {
            path: '/categoryList',
            redirect:'/home',
            meta: [],
        },
          {
              path: '/2020d',
              redirect:'/home',
          },
          {
              path: '/2020gsj',
              redirect:'/home',
          },
          {
              path: '/2021page',
              redirect:'/home',
          },
          {
              path: '/2022',
              redirect:'/home',
          },
          {
              path: '/2023',
              redirect:'/home',
          },
          {
              path: '/2023xCSDN',
              redirect:'/home',
          },
        {
          path:'/categoryDetails',
          redirect:'/home',
        },
        {
          path: '/activity',
          redirect:'/home'
        },
        {
          path:'/activityList',
          redirect:'/home',
        },{
          path:'/newActivity',
          redirect:'/home',
        },
        {
          path:'/activityDetails',
          redirect:'/home',
        },
        {
          path:'/activityRegistration',
          redirect:'/home',
        },
        {
          path:'/course',
          redirect:'/home',
        },
        {
          path:'/courseDetails',
          redirect:'/home',
        },
        {
          path:'/achievements',
          redirect:'/home',
        },
        {
          path:'/achievementsDetails',
          redirect:'/home',
        },
        {
          path:'/userInfo',
          redirect:'/home',
        }
      ]
    },
    {
      path: '/manager',
      component: bs_index,
      children: [
          {
            path: '',
            redirect:'/bsUserList'
          },{
            path:'/bsUserList',
            component: bsUserList,
            meta: [],
          },{
            path:'/bsActivityList',
            component:bsActivityList,
            meta:[],
          },{
            path:'/bsRegistration',
            component:bsRegistration,
            meta:[],
          },{
            path:'/bsAchievementList',
            component:bsAchievementList,
            meta:[],
          },{
            path:'/bsCourseList',
            component:bsCourseList,
            meta:[],
          },
      ]
    },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js